import num from '@nerdwallet/nw-client-lib/num';

const formatOutput = (data: any): (string | undefined)[] => {
  const originalHomePrice: number = data.outputs.suggestedPurchasePrice;
  const adjustedHomePrice: number = data.adjustedOutputs.suggestedPurchasePrice;
  const homeValueStr: string =
    adjustedHomePrice > 0 ? num.formatCurrency(adjustedHomePrice) : '_ _';
  const suggestedPrice: string | undefined =
    originalHomePrice !== adjustedHomePrice
      ? num.formatCurrency(originalHomePrice)
      : undefined;
  const formattedMonthlyPayment: string = num.formatCurrency(
    data.adjustedOutputs.monthlyPayments.total
  );

  return [homeValueStr, suggestedPrice, formattedMonthlyPayment];
};

export default formatOutput;
